import {
  FormVersionRequestParams,
  FormVersionRequestQuery,
  FormVersionEditionsRequestParams,
  FormVersionEditionsRequestQuery,
} from '@lio/api-types';

export const formVersionQueryKeys = {
  resource: 'form-versions' as const,
  get: (quoteId?: string) => [formVersionQueryKeys.resource, quoteId] as const,
  searchWithParams: (params?: FormVersionRequestParams & FormVersionRequestQuery) =>
    [...formVersionQueryKeys.get(params?.quoteId), params] as const,
  editions: (params?: FormVersionEditionsRequestParams & FormVersionEditionsRequestQuery) =>
    [...formVersionQueryKeys.get(params?.quoteId), 'editions', params] as const,
};
